module.exports = __webpack_public_path__ + "static/media/play-board-intro-5.a143fe4b.png";